
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, HostBinding, Input, NgModule, OnChanges, Optional, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterial } from '../../../angular-material';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnChanges, ControlValueAccessor {
  @HostBinding('class.disabled') isDisabled: boolean = false;
  isOpen: boolean = false;
  @Input() options: any[] = [];
  @Input() optionLabel: string = '';
  @Input() optionValue: string = '';
  @Input() placeholder: string = '';
  value: any;
  valueInput: any = '';
  onChange: (provinceData: any) => void;
  onTouch: (provinceData: any) => void;
  constructor(
    @Optional() private control: NgControl
  ) {
    if (this.control) {
      this.control.valueAccessor = this
    }
  }
  get filterOptions() {
    return this.options.filter(e => e[this.optionLabel]?.toLowerCase()?.indexOf(this.valueInput?.toLowerCase()) >= 0)
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.hasOwnProperty('options') && this.optionLabel) {
      this.options.forEach(e => {
        e[this.optionLabel] = this.optionLabel.replace(/\$\{(\w+)\}/g, (match, key) => e[key])
      })
    }
  }
  select(data: any) {
    if (this.optionValue) {
      this.onChange(data[this.optionValue]);
    } else {
      this.onChange(data)
    }
    this.valueInput = data[this.optionLabel];
    this.isOpen = false;
  }
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: (provinceData: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: (provinceData: any) => void): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AutocompleteComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterial,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
  ],
  exports: [
    AutocompleteComponent,
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutocompleteComponent),
    multi: true
  }]
})
export class AutocompleteModule { }